import { useEffect } from "react";

function useTitle (title : string ) {
    useEffect(() => {
        document.title = `${title} | Akylix`;
    });
}

export default useTitle;